import {useContext, useState} from "react";
import {FaRegUserCircle, FaTimes, FaUsers} from "react-icons/fa";
import {LoadingContext, ToastContext, UserContext} from "../../contexts";
import {UserApi} from "../../apis";
import {useNavigate} from "react-router";
import {Switcher} from "../Switcher";
import NoPic from "../../assets/img/no-pic.jpg";

export const UserEditor = ({item, key, update}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const {setLoading} = useContext(LoadingContext);
  const [itemDetalhes, setItemDetalhes] = useState(null);
  const {user} = useContext(UserContext);

  const navigate = useNavigate();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const openArquivo = async () => {
    setLoading(true);
    try {
      let respostaGetItem = await UserApi.getUser(user.uuid, item.uuid);
      if (!respostaGetItem.error) {
        await setItemDetalhes(respostaGetItem.data);
        setModalOpen(true);
        setLoading(false);
      } else {
        setLoading(false);
        AddToast({texto: respostaGetItem.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
    setLoading(false);
  }

  const toggleStatus = async () => {
    setLoading(true);
    try {
      let respostaStatus = await UserApi.toggleStatus(user.uuid, item.uuid);
      if (!respostaStatus.error) {
        setLoading(false);
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
      } else {
        setLoading(false);
        AddToast({texto: respostaStatus.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
    update();
  }

  const resetSenha = async () => {
    setLoading(true);
    try {
      let respostaReset = await UserApi.resetSenha(user.uuid, item.uuid);
      if (!respostaReset.error) {
        setLoading(false);
        AddToast({texto: "Sucesso!", tipo: "sucesso"});
      } else {
        setLoading(false);
        AddToast({texto: respostaReset.error, tipo: "erro"});
      }
    } catch (e) {
      setLoading(false);
      AddToast({texto: e, tipo: "erro"});
    }
    update();
  }

  return (
    <div className="arquivo" key={key}>
      <div className="arquivo-item">
        <div className="publicacao-info">
          <div className="avatar">
            <img src={item.avatar ? item.avatar : NoPic} alt={item.nome}/>
          </div>
          <div className="dados-user">
            <span className="nome">{item.nome}</span>
            <span className="cpf">Matrícula: {item.matricula}</span>
            <span className="funcao">Função: {item.funcao}</span>
            <span className="cpf">CPF: {item.cpf}</span>
            <span className="cpf">Loja: {item.loja}</span>
          </div>
        </div>
        <div className="opcoes">
          <div className="switch">
            <Switcher checked={item.status} onClick={toggleStatus}/>
          </div>
          <div className="btn btn-cancelar" onClick={openArquivo}>
            <span>Visualizar</span>
          </div>
          <div className="btn btn-editar"
               onClick={() => navigate('/portalcolaborador/user/edit', {state: {uuid: item.uuid}})}>
            <span>Editar</span>
          </div>
          {/*<div className="btn btn-primary" onClick={resetSenha}>*/}
          {/*  <span>Reiniciar senha</span>*/}
          {/*</div>*/}
        </div>
      </div>

      {modalOpen &&
        <div className="tela-modal-arquivo">
          <div className="modal-arquivo">
            <div className="modal-arquivo-cabecalho">
              <div className="titulo">
                <FaUsers size={30}/>
                <span>Usuários</span>
              </div>
              <div className="btn btn-primary" onClick={() => {setModalOpen(false)}}>
                Fechar(<FaTimes/>)
              </div>
            </div>
            <div className="informacoes">
              <div className="avatar">
                {itemDetalhes.avatar ?
                  <img src={itemDetalhes.avatar} alt="User avatar"/>
                  :
                  <FaRegUserCircle size={180}/>
                }
              </div>
              <div className="d-flex direction-column">
                <h2 className="titulo">{itemDetalhes.nome}</h2>
                <h3>CPF: {itemDetalhes.cpf}</h3>
                <h3>Função: {itemDetalhes.funcao}</h3>
              </div>

            </div>
          </div>
        </div>
      }
    </div>
  );
}